import api from "./api"


const cleanParams = (
  params = {}
) =>
  Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) =>
        value !== undefined &&
        value !== null &&
        value !== "" &&
        value !== "all"
    )
  )


export const getAccountingFormData = async () => {
  const response = await api.get("/accounting/form-data")
  return response.data
}


export const getAccountingDashboard = async (params = {}) => {
  const response = await api.get(
    "/accounting/dashboard",
    { params: cleanParams(params) }
  )
  return response.data
}


export const getAccountingAccounts = async (params = {}) => {
  const response = await api.get(
    "/accounting/accounts",
    { params: cleanParams(params) }
  )
  return response.data
}


export const createAccountingAccount = async (payload) => {
  const response = await api.post(
    "/accounting/accounts",
    payload
  )
  return response.data
}


export const updateAccountingAccount = async (
  accountId,
  payload
) => {
  const response = await api.put(
    `/accounting/accounts/${accountId}`,
    payload
  )
  return response.data
}


export const getAccountingJournals = async () => {
  const response = await api.get("/accounting/journals")
  return response.data
}


export const createAccountingJournal = async (payload) => {
  const response = await api.post(
    "/accounting/journals",
    payload
  )
  return response.data
}


export const updateAccountingJournal = async (
  journalId,
  payload
) => {
  const response = await api.put(
    `/accounting/journals/${journalId}`,
    payload
  )
  return response.data
}


export const getAccountingEntries = async (params = {}) => {
  const response = await api.get(
    "/accounting/entries",
    { params: cleanParams(params) }
  )
  return response.data
}


export const getAccountingEntryById = async (entryId) => {
  const response = await api.get(
    `/accounting/entries/${entryId}`
  )
  return response.data
}


export const createAccountingEntry = async (payload) => {
  const response = await api.post(
    "/accounting/entries",
    payload
  )
  return response.data
}


export const cancelAccountingEntry = async (
  entryId,
  payload = {}
) => {
  const response = await api.post(
    `/accounting/entries/${entryId}/cancel`,
    payload
  )
  return response.data
}


export const getGeneralLedger = async (params = {}) => {
  const response = await api.get(
    "/accounting/general-ledger",
    { params: cleanParams(params) }
  )
  return response.data
}


export const getTrialBalance = async (params = {}) => {
  const response = await api.get(
    "/accounting/trial-balance",
    { params: cleanParams(params) }
  )
  return response.data
}


export const getAccountingMappings = async () => {
  const response = await api.get("/accounting/mappings")
  return response.data
}


export const createAccountingMapping = async (payload) => {
  const response = await api.post(
    "/accounting/mappings",
    payload
  )
  return response.data
}


export const updateAccountingMapping = async (
  mappingId,
  payload
) => {
  const response = await api.put(
    `/accounting/mappings/${mappingId}`,
    payload
  )
  return response.data
}


// Compatibility aliases
export const getFinanceDashboard = getAccountingDashboard
export const getChartOfAccounts = getAccountingAccounts
export const getJournalEntries = getAccountingEntries
